export default "__VITE_ASSET__DHzIinLn__"